export const msToTime = (duration) => {
  let minutes = Math.floor((duration / (1000 * 60)) % 60),
    hours = Math.floor(duration / (1000 * 60 * 60));
  hours = hours < 10 ? hours : hours;
  minutes = minutes < 10 ? minutes : minutes;

  if (hours === 0) {
    return minutes + ' min ';
  }
  return hours + ' hrs ' + minutes + ' min ';
};

export const getSecondsFromHHMMSS = (time) => {
  if (time?.includes('_') || time === '') return 0;
  let [hours, minutes] = time.split(':').map(Number);

  hours = isNaN(hours) ? 0 : hours;
  minutes = isNaN(minutes) ? 0 : minutes;

  return hours * 3600 + minutes * 60;
};

export const getHHMMSSFromSeconds = (secs) => {
  let seconds = parseInt(secs);
  if (isNaN(seconds)) {
    return '00:00';
  }
  let hours =
    seconds >= 0 ? Math.floor(seconds / 3600) : Math.ceil(seconds / 3600);
  let minutes =
    seconds >= 0
      ? Math.abs(Math.floor((seconds % 3600) / 60))
      : Math.abs(Math.ceil((seconds % 3600) / 60));
  seconds = seconds % 60;
  return `${hours.toString().padStart(2, '0')}:${minutes
    .toString()
    .padStart(2, '0')}`;
};
export const getSecondsFromHHMM = (hhmm) => {
  if (!hhmm) return 0; // Handle empty or invalid values
  const [hours, minutes] = hhmm.split(':').map(Number);
  return hours * 3600 + minutes * 60; // Convert to total seconds
};

export const getDaysFromNumber = (number) => {
  let num = parseInt(number);
  if (isNaN(num)) {
    return '0 days';
  }
  return num === 1 ? `${num} day` : `${num} days`;
};
